import {
  LETTER_HISTORY_REPORT_FREE_AND_REDUCED_MODE_FORM_NAME,
  LETTER_HISTORY_REPORT_POINT_OF_SALE_MODE_FORM_NAME,
} from 'Common/FormEnum';

export const FormTypes = [
  {
    name: LETTER_HISTORY_REPORT_POINT_OF_SALE_MODE_FORM_NAME,
    text: 'Point of Sale',
    value: 0,
  },
  {
    name: LETTER_HISTORY_REPORT_FREE_AND_REDUCED_MODE_FORM_NAME,
    text: 'Free and Reduced',
    value: 1,
  },
];

export const PosModeLetterTemplateFilters = {
  LetterCategoryId: 1,
  LanguageId: 1,
};

export const FreeAndReducedModeLetterTypes = [
  {
    text: 'Notification Letters',
    key: 'N',
    value: 'N',
  },
  { text: 'CEP Transfer Notification Letters', key: 'C', value: 'C' },
  {
    text: 'Verification Selection Letters',
    key: 'S',
    value: 'S',
  },
  {
    text: 'Verification Results Letters',
    key: 'R',
    value: 'R',
  },
  {
    text: 'Direct Certified',
    key: 'D',
    value: 'D',
  },
  {
    text: 'Meal Benefit Expiration',
    key: 'M',
    value: 'M',
  },
];

export const SortByOptions = [
  { label: 'Family Number', value: 'family-number' },
  { label: 'Alpha', value: 'alpha' },
  { label: 'Letter Date/Alpha', value: 'letter-date' },
];

export const StatusOptions = [
  { text: 'Free', value: '2', key: 2 },
  { text: 'Reduced', value: '3', key: 3 },
  { text: 'Paid', value: '4', key: 4 },
];



// WEBPACK FOOTER //
// ./src/pages/letterhistoryreport/constants/index.js